import { UNAVAILABLE_FEATURES_CONTENT } from '@dmi/shared/redux/Main/constants';

const {
  defaultContent,
  loansChangeMailingContent,
  lossDraftContent,
  secureMessagingContent,
} = UNAVAILABLE_FEATURES_CONTENT;

export const pathnameDictionary = {
  default: defaultContent,
  LossDraft: lossDraftContent,
  MailingAddressUploadDocument: loansChangeMailingContent,
  SecureMessaging: secureMessagingContent,
};
